var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#222c3c;}.cls-2{fill:none;}")),React.createElement("title",{"key":1},"Show Menu"),React.createElement("rect",{"className":"cls-1","y":"3","width":"24","height":"3","rx":"1.5","ry":"1.5","key":2}),React.createElement("rect",{"className":"cls-1","x":"5.66667","y":"10.5","width":"18.33333","height":"3","rx":"1.5","ry":"1.5","key":3}),React.createElement("rect",{"className":"cls-1","y":"18","width":"24","height":"3","rx":"1.5","ry":"1.5","key":4}),React.createElement("rect",{"className":"cls-2","width":"24","height":"24","key":5})]);
}

Menu.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
